var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-callout",
    {
      staticClass: "mb-3 callout",
      attrs: {
        "border-color": _vm.getColorStatus(_vm.value.status),
        "has-toggle": false,
        opened: _vm.isOpen
      }
    },
    [
      _c("div", { staticClass: "row mt-2 row-container" }, [
        _c("div", { staticClass: "col-md-1 col-12 border-right status" }, [
          _c("div", { staticClass: "row align-items-center" }, [
            _c("div", { staticClass: "col-12 d-none d-md-block" }, [
              _c("div", { staticClass: "label" }, [_vm._v("Año Fiscal:")]),
              _c("span", { staticClass: "info" }, [
                _vm._v(" " + _vm._s(_vm.value.academicYear) + " ")
              ])
            ]),
            _c(
              "div",
              { staticClass: "col-7 col-md-12 mt-md-4" },
              [
                _c("custom-balloon", {
                  staticClass: "w-md-90 w-100 m-0",
                  attrs: {
                    "background-color": ` bg-${_vm.getColorStatus(
                      _vm.value.status
                    )}`,
                    text: _vm.value.status.name
                  }
                })
              ],
              1
            ),
            _c("div", { staticClass: "col-12 d-none d-md-block mt-md-4" }, [
              _c("div", { staticClass: "label" }, [_vm._v("Tipo de Ajuste:")]),
              _c("span", { staticClass: "info" }, [
                _vm._v(" " + _vm._s(_vm.value.adjustmentType) + " ")
              ])
            ])
          ])
        ]),
        _c("div", { staticClass: "col-12 col-md-11" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 col-md-4 mt-4 mt-md-0" }, [
              _c("div", { staticClass: "label" }, [_vm._v("Nombre:")]),
              _c("span", { staticClass: "info" }, [
                _vm._v(" " + _vm._s(_vm.value.name) + " ")
              ])
            ]),
            _c("div", { staticClass: "col-12 col-md-3 mt-4 mt-md-0" }, [
              _c("div", { staticClass: "label" }, [_vm._v("Monto:")]),
              _c("span", { staticClass: "info" }, [
                _vm._v("$" + _vm._s(_vm._f("currency")(_vm.value.amount)))
              ])
            ]),
            _c("div", { staticClass: "col-12 col-md-3 mt-4 mt-md-0" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v("Cantidad de Excepciones:")
              ]),
              _c("span", { staticClass: "info" }, [
                _vm._v(" " + _vm._s(_vm.value.exceptions) + " ")
              ])
            ]),
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-md-2 mt-4 mt-md-0 d-none d-md-flex align-items-start"
              },
              [
                _c("dropdown", {
                  staticClass: "actions-dropdown",
                  attrs: {
                    "data-item": { value: _vm.value, index: _vm.index },
                    items: _vm.actionItems,
                    title: "Acciones"
                  }
                })
              ],
              1
            ),
            _c("div", { staticClass: "col-12 mt-4 mb-2" }, [
              _c("div", { staticClass: "label" }, [_vm._v("Descripción:")]),
              _c("span", { staticClass: "info" }, [
                _vm._v(" " + _vm._s(_vm.value.description) + " ")
              ])
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }